import LoadingSpinner from "../common/Loading";
import React, { useState, useEffect } from "react";
import log from "../core/log";
import { getUsers } from "../Api/ApiCalls";
import { useTable, usePagination } from "react-table";

export const ViewUsers = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState([]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Corporation Code",
        accessor: "corporation_code",
      },
      {
        Header: "Organization Code",
        accessor: "organization_code",
      },
      {
        Header: "User Name",
        accessor: "user_name",
      },
      {
        Header: "Email ID",
        accessor: "email_address",
      },

      {
        Header: "Phone Number",
        accessor: "phone_number",
        Cell: ({ row }) => {
          return (
            <>
              <span>{row?.original?.country_code}</span>
              <span>{row?.original?.phone_number}</span>
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );

  const getUser = async () => {
    try {
      setLoading(true);
      const data = await getUsers("user");
      if (data) {
        setUser(data);
      }
      setLoading(false);
    } catch (err) {
      log(`Error while fetching user: `, err);
      setLoading(false);
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    pageOptions,
    state,
    setPageSize,
    pageSize,
  } = useTable({ columns, data: user }, usePagination);
  const { pageIndex } = state;

  useEffect(() => {
    getUser();
    setPageSize(25);
  }, []);

  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-10">
            <h2 className="text-4xl text-[#96BF61] font-bold mb-6">Users</h2>

            {loading && <LoadingSpinner />}
            {user.length !== 0 && (
              <div className="grid grid-cols-12 mt-5">
                <div className="col-span-12 lg:col-span-12">
                  <div className="">
                    <div className="">
                      <div className=" overflow-y-scroll rounded-[21px] rounded-bl-none rounded-br-none">
                        <table
                          className="min-w-full border manage-user"
                          id="table"
                          {...getTableProps()}
                        >
                          <thead className=" border bg-white">
                            {headerGroups.map((headerGroup) => (
                              <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                  <th
                                    data-type="number"
                                    scope="col"
                                    className="font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-2 py-6 "
                                    {...column.getHeaderProps()}
                                  >
                                    {column.render("Header")}
                                  </th>
                                ))}
                              </tr>
                            ))}
                          </thead>

                          <tbody {...getTableBodyProps()}>
                            {page.map((row) => {
                              prepareRow(row);
                              return (
                                <tr
                                  className="bg-white border transition duration-300 ease-in-out hover:bg-gray-100"
                                  {...row.getRowProps()}
                                >
                                  {row.cells.map((cell) => (
                                    <td
                                      className="text-gray-900 border border-r-0 border-l-0 font-light px-2 py-6 text-[13px]"
                                      {...cell.getCellProps()}
                                    >
                                      <span>{cell.render("Cell")}</span>
                                    </td>
                                  ))}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <div className="mt-6 flex justify-end items-center">
                          <div className="mr-4">
                            <span className="text-[#121212]">
                              Items per page
                            </span>
                          </div>
                          <div className="relative mr-4 ">
                            <select
                              value={pageSize}
                              onChange={(e) =>
                                setPageSize(Number(e.target.value))
                              }
                              className="border border-[#024C85] pl-6 pr-9 rounded-md outline-none bg-[#EDF9FF] font-bold text-[#024C85]"
                            >
                              {[25, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                            <div className="absolute right-[7px] top-[15px] pointer-events-none">
                              <svg width="20" height="20" viewBox="0 0 24 24">
                                <path
                                  d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                  fill="#1D192B"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <span className="mr-4">
                              Page {pageIndex + 1} of {pageOptions.length}
                            </span>
                            <button
                              className={`${
                                !canPreviousPage
                                  ? "bg-[#EDF9FF]"
                                  : "bg-tranparent"
                              } px-[22px] py-[10px] rounded-[4px] mr-4 cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                              onClick={() => previousPage()}
                              disabled={!canPreviousPage}
                            >
                              <svg
                                width="8"
                                height="10"
                                viewBox="0 0 8 10"
                                fill="none"
                              >
                                <path
                                  d="M7.08748 1.175L5.91248 0L0.912476 5L5.91248 10L7.08748 8.825L3.27081 5L7.08748 1.175Z"
                                  fill="#024C85"
                                />
                              </svg>
                            </button>
                            <button
                              className={`${
                                !canNextPage ? "bg-[#EDF9FF]" : "bg-tranparent"
                              } px-[22px] rounded-[4px] py-[10px] cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                              onClick={() => nextPage()}
                              disabled={!canNextPage}
                            >
                              <svg
                                width="8"
                                height="10"
                                viewBox="0 0 8 10"
                                fill="none"
                              >
                                <path
                                  d="M2.08748 0L0.912476 1.175L4.72914 5L0.912476 8.825L2.08748 10L7.08748 5L2.08748 0Z"
                                  fill="#024C85"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!loading && user.length === 0 && (
              <h2 className="text-2xl font-medium mr-auto text-gray-500 text-center mt-[10%]">
                No Data Found!
              </h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
